/* Keep the signup offer outside the page's H1 outline without changing its design. */
(() => {
  const selector = '#rich-text-01M4YVCK52HAD684TJK7J3VQB9 > h1';
  const expected = new Set(['Get 10% off', 'Your First Order']);
  function normalize() {
    document.querySelectorAll(selector).forEach((heading) => {
      if (!expected.has(heading.textContent.trim())) return;
      const replacement = document.createElement('p');
      for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
      const style = getComputedStyle(heading);
      ['font-family', 'font-size', 'font-weight', 'line-height', 'letter-spacing', 'color', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'text-align'].forEach((property) => {
        replacement.style.setProperty(property, style.getPropertyValue(property));
      });
      while (heading.firstChild) replacement.appendChild(heading.firstChild);
      heading.replaceWith(replacement);
    });
  }
  normalize();
  new MutationObserver(normalize).observe(document.body, { childList: true, subtree: true });
})();
